// extracted by mini-css-extract-plugin
module.exports = {"headline":"headline_headline__2cTc1","h1":"headline_h1__1pRsi","h2":"headline_h2__3GZGB","red":"headline_red__1hCfw"};